module.exports = __webpack_public_path__ + "static/img/NZ@3x.b0712fce.png";